import { CommonModule } from '@angular/common';
import { Component, Input, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-system-breadcrumb',
  templateUrl: './breadcrumb.component.html',
})
export class BreadcrumbComponent {
  @Input({
    required: true,
  })
  items: {
    title: string;
    link: string;
  }[] = [];
  constructor() {}
}

@NgModule({
  declarations: [BreadcrumbComponent],
  exports: [BreadcrumbComponent],
  imports: [RouterModule, TranslateModule, CommonModule],
})
export class SystemBreadcrumbModule {}
